<template>
  <div>
    <div class="areas swiper_loading">
      <!-- pc -->
    <div class="swiper-container swiper-one pcswiper">
      <div class="swiper-wrapper swiper-no-swiping">
        <div v-for="(item,index) in imgData" :key="index" class="swiper-slide swiper-slide-active swiper-slide1">
            <img class="img100 onlyTD" :src="item.pcPicture" v-if="item.type === 'jpg'||item.type === 'png'||item.type === 'peg'" />
            <img class="img100 onlyTD" :src="item.pcPicture + '?' + datatime" v-if="item.type === 'gif' && index === swiperflageindex"   />
            <video autoplay="true" muted="true" ref="videoPl" data-origwidth="0" data-origheight="0" poster="false" playsinline class="video" v-if="item.type === 'mp4'">
              <source
                :src="item.pcPicture"
                type="video/mp4"
              />
              您的浏览器不支持 video 标签。
            </video>
            <div class="mask">
              <h2 class="title-text-2"><strong>{{ item.kvTitle }}</strong></h2>
              <p class="title-text-1">{{ item.kvContent }}</p>
              <a class="tolink commonBtn btnStyle2" target="_blank" @click="toLink(item.linkUrl)" v-if="item.linkUrl" :style="item.linkUrl!==''?'cursor: pointer':''"><span>{{ $t("homePage.readMore") }}</span></a>
            </div>
        </div>
      </div>
      <ul class="pagination">
        <li @click="slideTo(item)" :class="`pagination-item ${swiperflageindex === item - 1? 'active': ''}`" v-for="item in imgData.length" :key="item"></li>
      </ul>
      <button class="slick-prev slick-arrow" style="z-index:10" aria-label="Previous" type="button" @click="leftClick1()">Previous</button>
      <button class="slick-next slick-arrow" style="z-index:10" aria-label="Next" type="button" @click="rightClick1">Next</button>
    </div>
    <!-- moblie -->
     <div class="swiper-container swiper-two mbswiper" style="height:580px;">
      <div class="swiper-wrapper swiper-no-swiping">
        <div class="swiper-slide swiper-slide-active swiper-slide2" v-for="(item,index) in imgData" :key="index">
            <img class="img100" :src="item.mbPicture" v-if="item.types === 'jpg'||item.types === 'png'||item.type === 'peg'"/>
            <img class="img100" :src="item.mbPicture + '?' + datatime" v-if="item.types === 'gif' && index === swiperflageindexs" />
            <video :autoplay="true" ref="videoPl" data-origwidth="0" data-origheight="0" poster="false" playsinline class="video" v-if="item.types === 'mp4'" muted>
              <source
                :src="item.mbPicture"
                type="video/mp4"
              />
              您的浏览器不支持 video 标签。
            </video>
            <div class="maskmb">
              <h2>{{ item.kvTitle }}</h2>
              <p>{{ item.kvContent }}</p>
              <a class="tolink" target="_blank" @click="toLink(item.linkUrl)" v-if="item.linkUrl" :style="item.linkUrl!==''?'cursor: pointer':''">{{ $t("homePage.readMore") }}</a>
            </div>
        </div>
      </div>

      <ul class="pagination" style="bottom:2rem">
        <li @click="slideTos(item)" :class="`pagination-items ${swiperflageindexs === item - 1? 'active': ''}`" v-for="item in imgData.length" :key="item"></li>
      </ul>
      <button class="slick-prev slick-arrow" style="z-index:10" aria-label="Previous" type="button" @click="leftClick2">Previous</button>
      <button class="slick-next slick-arrow" style="z-index:10" aria-label="Next" type="button" @click="rightClick2">Next</button>
    </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
export default {
  props: ['imgData'],
  data () {
    return {
      swiperflage: true,
      swiperflageindex: 0,
      swiperflages: true,
      swiperflageindexs: 0,
      locale: '',
      timer: null,
      timers: null,
      swiper: null,
      swipers: null,
      datatime: '0',
      datatimes: '0',
      nextime: 3000,
      nextime1: 3000,
      maskShow:false,
      bool:true,
    }
  },
  created () {
    this.locale = localStorage.languageSet
  },
  mounted () {
    this.getpicFun()
    this.swiperFns()
    this.swiperFn()
     this.$nextTick(function () {
      // 滚动监听事件
      window.addEventListener('scroll', this.menu)
    })
  },
  methods: {
    getpicFun () {},
    slideTo (index) {
      this.swiper.slideTo(index)
    },
    slideTos (index) {
      console.log(index, this.swipers)
      this.swipers.slideTo(index)
    },
    toLink (item) {
      if (item !== '') {
        window.open(item)
        this.$gtag("event", "click", {
        site: localStorage.languageSet,
        page_group: this.$route.meta.pageGroup,
        event_category: "read more",
        event_label: "read more",
        send_to: "G-9LRNGL9NJ8",
      });
      }
    },
    swiperFn () {
      var that = this
      let o = 0
      let nextime = 3000
      var newSwiper = new Swiper('.swiper-one', {
        loop: true,
        // 如果需要分页器
        // pagination: '.swiper-pagination',
        // 前进后退按钮
        // nextButton: '.swiper-button-next',
        // prevButton: '.swiper-button-prev',
        pagination: '.swiper-pagination',
        nextButton: '.slick-next',
        prevButton: '.slick-prev',
        // 自动切换
        // autoplay: 5000,
        // autoplayDisableOnInteraction: false,
        // speed: 300,
        spaceBetween: 25,
        effect: 'fade',
        initialSlide: 0,
        observer: true, // swiper自己或子元素时，自动初始化swiper
        observeParents: true, // swiper的父元素时，自动初始化swiper
        onInit: function (swiper) {
        },
        onSlideChangeStart: function (swiper) {
          var length = that.imgData.length
          var mask = document.getElementsByClassName('swiper-slide1')[swiper.activeIndex].getElementsByClassName('mask')[0]
          var text2=mask.getElementsByClassName('title-text-2')[0]
          var text1=mask.getElementsByClassName('title-text-1')[0]
          var img=mask.getElementsByClassName('tolink')[0]
            if(swiper.activeIndex==0){
            img.src=that.imgData[length-1].linkUrl
            text2.innerHTML=that.imgData[length-1].kvTitle
            text1.innerHTML=that.imgData[length-1].kvContent
          }

          
          if (swiper.activeIndex === 0 || swiper.activeIndex === length) {
            o = length - 1
          } else if (swiper.activeIndex === length + 1 || swiper.activeIndex === 1) {
            o = 0
          } else {
            o = swiper.activeIndex - 1
          }
          that.swiperflageindex = o
         
          // o = o - 1
          let nextime = 3000

          var type = that.imgData[o].type
          if (type === 'mp4') {
            var vid = document.getElementsByClassName('swiper-slide1')[swiper.activeIndex].getElementsByTagName('video')[0]
            
            vid.autoplay = true
            var play = vid.play()
            vid.currentTime = 0
            if (play) {
              play.then(() => {
                // 视频频加载成功
                // 视频频的播放需要耗时

                vid.play()
                nextime = vid.duration * 1000
                clearTimeout(that.timer)
                that.timer = setTimeout(() => {
                  newSwiper.slideNext()
                }, nextime)
                // that.swiperflageindex = o
                // video[0].duration 为视频频的时长，单位为秒
              }).catch((e) => {
                // 视频频加载失败
                console.log('11111')
              })
            }
          } else {
            nextime = 3000
            clearTimeout(that.timer)
            that.timer = setTimeout(() => {
              newSwiper.slideNext()
            }, nextime)
            
          }
          // if (type !== 'gif') {
          //   that.datatime = new Date().getTime()
          // }
        }

      })
      this.swiper = newSwiper
      // this.swiperIndex = newSwiper.activeIndex
      console.log('newSwiper', newSwiper)
    },
    swiperFns () {
      var that = this
      let nextime = 3000
      var o = 0
      var newSwipers = new Swiper('.swiper-two', {
        loop: true,
        nextButton: '.slick-next',
        prevButton: '.slick-prev',
        pagination: '.swiper-pagination',
        // autoplayDisableOnInteraction: false,
        spaceBetween: 25,
        effect: 'fade',
        initialSlide: 0,
        observer: true, // swiper自己或子元素时，自动初始化swiper
        observeParents: true, // swiper的父元素时，自动初始化swiper
        onInit: function (swipers) {},
        onSlideChangeStart: function (swipers) {
          var length = that.imgData.length
          if (swipers.activeIndex === 0 || swipers.activeIndex === length) {
            o = length - 1
          } else if (swipers.activeIndex === length + 1 || swipers.activeIndex === 1) {
            o = 0
          } else {
            o = swipers.activeIndex - 1
          }
          that.swiperflageindexs = o
          let nextime = 3000
          var types = that.imgData[o].types
          if (types === 'mp4') {
            var vid = document.getElementsByClassName('swiper-slide2')[swipers.activeIndex].getElementsByTagName('video')[0]
            vid.autoplay = true
            var play = vid.play()
            vid.currentTime = 0
            if (play) {
              play.then(() => {
                // 视频频加载成功
                // 视频频的播放需要耗时
                clearTimeout(that.timers)

                vid.play()
                nextime = vid.duration * 1000
                clearTimeout(that.timers)
                that.timers = setTimeout(() => {
                  newSwipers.slideNext()
                }, nextime)
                // that.swiperflageindexs = o
                // video[0].duration 为视频频的时长，单位为秒
              }).catch((e) => {
                // 视频频加载失败
                console.log('11111')
              })
            }
          } else {
            nextime = 3000
            clearTimeout(that.timers)
            that.timers = setTimeout(() => {
              newSwipers.slideNext()
            }, nextime)
            // that.swiperflageindexs = o
          }
          // if (type !== 'gif') {
          //   that.datatime = new Date().getTime()
          // }
        }

      })
      this.swipers = newSwipers
      // this.swiperIndex = newSwiper.activeIndex
    },
    menu () {
      const _self = this
      _self.scroll = document.documentElement.scrollTop || document.body.scrollTop
      if (_self.scroll > $('.swiper_loading').offset().top - 150 && this.bool) {
        this.bool = false
        this.$gtag('event', 'impression', {
          site: localStorage.languageSet,
          page_group: this.$route.meta.pageGroup,
          event_category: 'banner picture',
          event_label: 'banner picture',
          send_to: 'G-9LRNGL9NJ8'
        })
      }
    },
    leftClick1 () {
      var that = this
       
      this.$gtag('event', 'click', {
        site: localStorage.languageSet,
        page_group: this.$route.meta.pageGroup,
        event_category: 'top banner',
        event_label: 'lefts',
        send_to: 'G-9LRNGL9NJ8'
      })
    },
    rightClick1 () {
      
      this.$gtag('event', 'click', {
        site: localStorage.languageSet,
        page_group: this.$route.meta.pageGroup,
        event_category: 'top banner',
        event_label: 'right',
        send_to: 'G-9LRNGL9NJ8'
      })
    },
     leftClick2 () {
      this.$gtag('event', 'click', {
        site: localStorage.languageSet,
        page_group: this.$route.meta.pageGroup,
        event_category: 'top banner',
        event_label: 'lefts',
        send_to: 'G-9LRNGL9NJ8'
      })
    },
    rightClick2 () {
      this.$gtag('event', 'click', {
        site: localStorage.languageSet,
        page_group: this.$route.meta.pageGroup,
        event_category: 'top banner',
        event_label: 'right',
        send_to: 'G-9LRNGL9NJ8'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.areas .pcswiper{
  height: 100vh;
}
.swiper-container {
  height: 614px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  z-index: 1;
  margin-top: 0px;
  background-color: #222121;
}
.swiper-slide{
  // position: absolute;
    // top: 0;
    // left: -50%;
    width: 100%;
    height: 100vh;
    background-size: cover;
    background-position: center;
    will-change: transform;
    text-align: center;
    background-color: #222121;
}
.video {
  width: 100%;
  height:auto;
  background-color: #222121;
  source{
    width: 100%;
    height: 50%;
  }
}
.pcswiper{
  display:block;
}
.mbswiper{
  display:none;
}
.maskmb{
  position:absolute;
  top:227px;
  color: #fff;
  text-align: left;
  padding: 0 15%;
  height: 22rem;
  background-color: #222121;
  // width: 70%;
  h2{
    line-height: 1.7rem;
    font-size: 1.3rem;
    margin:19px 0;
    strong{
      line-height: 45px;
    }
  }
  p{
    line-height: 1.5em;
    font-weight: 300;
    margin: 1em 0;
    font-size: 0.9rem;
    text-align: left;
    margin-top: 0.5rem;
  }
}
.pagination {
  position: absolute;
  z-index: 3;
  left: 50%;
  bottom: 4rem;
  transform: translateX(-50%);
  font-size: 0;
  list-style-type: none;
  padding: 0;
}
.pagination-item {
  width: 0.8rem;
  height: 0.8rem;
  position: relative;
  display: inline-block;
  vertical-align: top;
  background: #cbcbcb;
  margin: 0 0.5rem;
  border-radius: 50%;
  cursor: pointer;
  &.active {
    background: #2f9eef;
  }
  &:hover {
    background: #2f9eef;
  }
}
.pagination-items {
  width: 0.8rem;
  height: 0.8rem;
  position: relative;
  display: inline-block;
  vertical-align: top;
  background: #cbcbcb;
  margin: 0 0.5rem;
  border-radius: 50%;
  cursor: pointer;
  &.active {
    background: #2f9eef;
  }
}
.slick-prev::before,
.slick-next::before {
  color: rgba(255,255,255,.7);
  font-size: 54px;
  font-size: bold;
}
.slick-prev:hover::before,
.slick-next:hover::before {
  color: rgba(255,255,255,1);
}
.swiper-containerM {
  margin-top: 60px !important;
}
.btnStyle3:hover {
  // background: #385790;
  color: #fff;
  // border: none;
}
.mask {
  width: 32%;
  top: 35%;
  left: 55%;
  position: absolute;
  z-index: 100;
  text-align: left;
  .title-text-2 {
    padding: 10px;
    // padding-bottom: 0;
    margin: 0;
    background: url("../assets/homePage/home/bluebg.png");
  background-size: auto 100% ;
  background-repeat: repeat ;
  background-position: left top ;
    // background-color: rgb(1, 33, 91);
    // opacity: 0.6;
    font-size: 45px;
    line-height: 1.2em;
    color: #fff;
  }
  .title-text-1 {
    padding: 10px;
    padding-top: 0;
    margin: 0;
    background: url("../assets/homePage/home/bluebg.png");
  background-size: auto 100% ;
  background-repeat: repeat ;
  background-position: left top ;
    // background-color: rgb(1, 33, 91);
    // opacity: 0.6;
    font-size: 15px;
    line-height: 1.5em;
    color: #fff;
  }
  .title-text-2pc {
    font-size: 55px;
    margin: 0 0 5px 0;
    line-height: 60px;
    color: #fff;
    text-align: center;
    margin-top: 108px;
    text-shadow: 0 2px 0 #222121, 0 0 35px #222121;
  }
  .titlezh {
    margin-top: 132px;
  }
  .title-text-3pc {
    margin: 0 0 5px 0;
    color: #fff;
    text-align: center;
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
}
.tolink {
    background: #2F9EEF;
    margin-top: 40px;
    color: #fff;
    border-color: #2F9EEF;
    position: relative;
    display: inline-block;
    padding: 15px 20px;
    font-size: 15px;
    line-height: 1;
    text-align: center;
    overflow: hidden;
    text-decoration: none;
    transition: all 0.3s;
    box-sizing: border-box;
    cursor: pointer;
  }
@media screen and (max-width: 1200px) {
 .swiper-container {
  margin-top: 60px;
 }
}
@media screen and (max-width: 780px) {
 .pcswiper{
  display:none;
}
.mbswiper{
  display:block;
}
}

</style>
